module.exports = __webpack_public_path__ + "img/2.259cb95d.png";